export enum ClientServiceTypeEnum {
  Membership = 1,
  JetPass = 2,
  GroupMembership = 3,
  // legacy membership client service is UI concern only
  LegacyMembership = 10000,
}
